<template>
  <BaseCardV2
    titre="Poids total livré"
    has-help
    :loading="loading"
    @on-help="isOpenModalHelp = true"
  >
    <div
      v-if="!loading"
      class="flex-column mt-3"
    >
      <div class="d-flex justify-center">
        <span
          class=" align-self-center secondary--text"
          :class="$vuetify.breakpoint.mobile ? 'chiffre' : 'chiffre-xxl '"
        >
          {{ Math.round(repartitionApportParGraine.cumulPoidsAuxNormesEnKg / 1000 ) | roundNumber(0) }}
        </span>
        <span
          class="ml-2 align-self-center secondary--text"
          :class="$vuetify.breakpoint.mobile ? 'texte' : 'chiffre'"
        >t</span>
      </div>
      <div
        v-if="repartitionApportParGraine.evolutionCumulPoidsAuxNormesAnneePrecedenteEnKg"
        class="mt-2 d-flex justify-center"
      >
        <BaseEvolution
          :evolution-value="repartitionApportParGraine.evolutionCumulPoidsAuxNormesAnneePrecedenteEnKg / 1000"    
          :unite="'t'"
        />
      </div>
      <v-divider class="mx-3 my-6" />
      <div
        class="d-flex justify-center mb-6"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'h-300'"
      >
        <BaseDoughnutChartV2
          class="align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mt-2' : 'mr-5'"
          :chart-data="chartDataApport"
        />
        <div class="pt-2 align-self-center texte texte-gris-fonce">
          <v-chip
            label
            color="#00713C"
            class="mr-2"
          >
            <span class="white--text">{{ repartitionApportParGraine.cumulPoidsAuxNormesGraineSelectedEnPourcentage * 100 | roundNumber(0) }} % </span>
          </v-chip>
          <span class="texte">du tonnage livré</span>
        </div>
      </div>
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Poids total livré"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Visualisez ici le poids total livré aux normes ainsi que la part qu'il représente dans le total de vos apports.</p>
          <p>Cela vous permettra de relativiser les comparaisons qui suivent.</p>
        </div>
      </div>
    </HelpModal>
  </BaseCardV2>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseDoughnutChartV2 from '@/components/chart/base-doughnut-chart-v2.vue'
import BaseEvolution from '@/components/common/base-evolution.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import numberFilter from '@/filters/number.filter'

export default {
  name: 'PoidsTotalLivre',
  components: {BaseCardV2, BaseDoughnutChartV2, BaseEvolution, HelpModal},
  props: {
    codeGraineRs3Selected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      isOpenModalHelp: false
    }
  },
  computed: {
    ...mapGetters({
      repartitionApportParGraine: 'recolte/repartitionApportParGraine',
    }),
    chartDataApport () {
      return {
        id:'chartApports',
        datasets: [
          {
            legendTooltip: { title: 'tonnage livré', value: [numberFilter.formatNumber(this.repartitionApportParGraine.cumulPoidsAuxNormesGraineSelectedEnPourcentage * 100, 2), numberFilter.formatNumber(this.repartitionApportParGraine.cumulPoidsAuxNormesAutresGrainesEnPourcentage * 100, 2)], unit: '%' },
            backgroundColor: ['#00713C', '#F1F2F5'],
            data: [this.repartitionApportParGraine.cumulPoidsAuxNormesGraineSelectedEnPourcentage, this.repartitionApportParGraine.cumulPoidsAuxNormesAutresGrainesEnPourcentage]
          }
        ]
      }
    }
  },

  watch: {
    anneeRecolteSelected: {
      handler () {
        this.loadApports()
      },
      immediate: true
    },
    codeGraineRs3Selected () {
      this.loadApports()
    }
  },

  methods: {
    ...mapActions({
      fetchRepartitionApportParGraine: 'recolte/fetchRepartitionApportParGraine'
    }),

    loadApports () {
      this.loading = true
      this.fetchRepartitionApportParGraine({ anneeRecolteSelected: this.anneeRecolteSelected, codeGraineRs3Selected: this.codeGraineRs3Selected })
        .finally(() => {
          this.$emit('hasEvolution', this.repartitionApportParGraine.evolutionCumulPoidsAuxNormesAnneePrecedenteEnKg != null)
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.h-300 {
  height: 300px;
}

</style>